var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":"stickyline"}}),_c('p'),_c('main',[_c('div',{staticClass:"container-fixed offset-top-16 offset-bottom-17"},[_c('VSpinner')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }